import React from 'react';
import StatisticsProvider from '../../StatisticsProvider';
import LineChartGrid from '../../../../components/stats/LineChartGrid';

export default function Customers({ dateRangeFilter }) {
  return (
    <StatisticsProvider
      mainMetrics={['new_customers', 'new_followers', 'returning_customers', 'sales_from_email']}
      marketingMetrics={['average_open_rate', 'total_delivered', 'average_click_rate']}
      displayOrder={[
        'new_customers',
        'new_followers',
        'returning_customers',
        'total_delivered',
        'average_open_rate',
        'average_click_rate',
        'sales_from_email',
      ]}
      withInterval
      dateRangeFilter={dateRangeFilter}
    >
      <LineChartGrid />
    </StatisticsProvider>
  );
}
